export default "__VITE_ASSET__BZvpmcUk__"